<template>
    <DefaultLayout>
        <CourseFeed />
        <router-view />
    </DefaultLayout>
</template>
<script>
import CourseFeed from './feed/index.vue';
import DefaultLayout from '../layouts/default/';

export default {
    components: {
        CourseFeed,
        DefaultLayout,
    },
    methods: {
    },
};
</script>